import localforage from 'localforage'
import { config } from '@config/network.js'
/**
 * 格式化时间戳
 * @param {String | Number} unixTime 当前需要格式化的时间戳
 * @param {Boolean} isFull 是否需要显示时分秒
 * @param {Boolean} today 当前时间戳是今天是否要显示年月日
 */
export const myTime = (unixTime, isFull, timeZone,today) => {
    if (typeof (timeZone) == 'number') {
        unixTime = parseInt(unixTime) + parseInt(timeZone) * 60 * 60;
    }
    var time = unixTime.length < 13 ? new Date(unixTime * 1000) : new Date(unixTime);
    var ymdhis = "";

    if(today){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();

        //如果当前日期等于时间戳的日期，则只返回时分秒
        if(year == time.getFullYear() && month == time.getMonth() + 1 && day == time.getDate()){

        }else{
            ymdhis += time.getFullYear() + "-";
            ymdhis += (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) + "-" : (time.getMonth() + 1) + "-";
            ymdhis += time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
        }
    }else{
        ymdhis += time.getFullYear() + "-";
        ymdhis += (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) + "-" : (time.getMonth() + 1) + "-";
        ymdhis += time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
    }
    if (isFull === true) {
        ymdhis += " " + time.getHours() < 10 ? " " + '0' + time.getHours() + ":" : " " + time.getHours() + ":";
        ymdhis += time.getMinutes() < 10 ? '0' + time.getMinutes() + ":" : time.getMinutes() + ":";
        ymdhis += time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
    }
    return ymdhis;
}

/**
 * 添加事件监听
 * @param {HTMLElement} obj 当前需要坚挺的对象
 * @param {String} eventName 所坚监听的事件名
 * @param {Function} func 监听事件回调
 * @param {Boolean} capture 是否允许冒泡
 */
export const addEventListener = (obj, eventName, func, capture) => {
    var capture = capture || false;
    obj.addEventListener(eventName, func, capture);
    return function() {
        obj.removeEventListener(eventName, func, capture);
    }
}

/**
 * 在新窗口打开页面
 * @param {String} url 新窗口页面地址
 */
export const openWindow = (url) => {
    let {
        origin,
        pathname
    } = window.location
    window.open(`${origin}${pathname}${url}`)
}

/**
 * 保存全局缓存
 * @param {String} uid 当前用户唯一id
 * @param {String} localName 缓存名称
 * @param {String | Number | Object} value 需要保存的内容
 * @param {Number} max 单个用户可以保存的最大条数
 * @param {Number} order 当保存类型为数组时，是要将数据添加到最前面还是最后面 1：前面 -1 后面
 * @param {Number} type 保存类型 1：数组  2：对象
 * @param {String} key 当前保存类型为对象时，对象的key值
 * @param {String} id 如果当前保存的值为数组对象，需要提供保证数据唯一的标识
 */
export const saveUserLocal = async (param) => {
    let userInfo = await localforage.getItem('userInfo') || {}
    let {
        uid = userInfo.uid,
        localName = checkFn('localName是必填字段'),
        value = checkFn('value是必填字段'),
        max = 0,
        order = 1,
        type = 1,
        key,
        id = ''
    } = param
    let histroy = await localforage.getItem(localName) || {}
    let userHistroy = null
    // 为数组
    if (type === 1) {
        userHistroy = histroy[uid] || []
        // 如果没有指定需要保存唯一的id，则单纯对比一下
        if (!id) {
            let index = userHistroy.indexOf(value)
            // 如果当前值已经存在，则先删除本地的再添加
            if (index !== -1) {
                userHistroy.splice(index, 1)
            }
        } else {
            for (let i = 0, len = userHistroy.length; i < len; i++) {
                if (userHistroy[i][id] === value[id]) {
                    userHistroy.splice(i, 1)
                    break
                }
            }
        }
        
        if (order === 1) {
            userHistroy.unshift(value)
            // 当前有设置最大值，并且当前已经超出最大值，则删掉最后的超出部分
            if (max && userHistroy.length > max) {
                userHistroy = userHistroy.slice(0, max)
            }
        } else if (order === -1) {
            userHistroy.push(value)
            // 当前有设置最大值，并且当前已经超出最大值，则删掉最后的超出部分
            if (max && userHistroy.length > max) {
                userHistroy.slice(userHistroy.length - max, userHistroy.length)
            }
        }
    } else if (type === 2) {
        userHistroy = histroy[uid] || {}
        userHistroy[key] = value
    }
    histroy[uid] = userHistroy
    localforage.setItem(localName, histroy)
    return userHistroy
}


export const objectToKeyValueArray = (obj)=>{
    let arr = []
    for(let key in obj){
        arr.push({
            key,
            value: obj[key]
        })
    }
    return arr
}

export const getqxbURL = (extend, show_left)=>{
    const token = localStorage.getItem('qxb_token')
    return `${config.QXB_WEB}v5.10.6/index.php?token=${token}&hide_left=${show_left ? 0 : 1}&${extend}&source=CHANGYUAN&client=PC#!/login`
}

/**
 * 秒数转换为时分秒
 * @param {Number} seconds 秒数
 */
export const secondsFormat = (seconds) => {
    let minutes = 0;
    let hours = 0;
    seconds = parseInt(seconds)

    if (seconds > 60) {
        minutes = parseInt(seconds / 60);
        seconds = parseInt(seconds % 60);
        if (minutes > 60) {
            hours = parseInt(minutes / 60);
            minutes = parseInt(minutes % 60);
        }
    }
    let result = '' + parseInt(seconds) + '秒';
    if (minutes > 0) {
        result = '' + parseInt(minutes) + '分' + result;
    }
    if (hours > 0) {
        result = '' + parseInt(hours) + '小时' + result;
    }
    return result;
}
/**
 * 生成随机字串  -16位, 生成16位的消息crc
 * @param  {Number} [len=16]  - 随机字符串的长度
 * @return {string}           - 随机字符串
 */
 export const randomString = (len = 16) => {
	// 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
	var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
	var maxPos = $chars.length
	var pwd = ''
	for (var i = 0; i < len; i++) {
		pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return pwd
}



// WEBPACK FOOTER //
// ./src/assets/js/ulits.js